export default __webpack_public_path__ + "static/media/intro-cat.bebf6f04.png";